import React from 'react';
import { getDescription, getSafeName } from '../../selectors';
import FormatCodeInHtml from '../FormatCodeInHtml';
import IFrame from '../IFrame';
import copy from '../copy';
interface Props {
  app: any;
}

// Display just LAMP for now, we will be adding more videos once we fully
// adopt this experiment: https://jira.internal.digitalocean.com/browse/MP-3506
const VIDEOS = {
  lamp: '/static/LAMP-promo.mp4'
};

const Description: React.FC<Props> = ({ app }) => {
  const safeName = getSafeName(app);
  const description = getDescription(app);
  const videoUrl = VIDEOS[safeName];

  if (!description) {
    return null;
  }

  return (
    description && (
      <>
        <h2>Description</h2>
        <IFrame
          title={copy.appDetails.descriptionTitle}
          id={`${safeName}-description-frame`}
        >
          <FormatCodeInHtml htmlStr={description} />
        </IFrame>
        {videoUrl && (
          <video controls width="100%" className="do-u-mt--medium">
            <source src={videoUrl} type="video/mp4" />
            Sorry, your browser doesn't support embedded videos.
          </video>
        )}
      </>
    )
  );
};

export default Description;
